import React, { useEffect } from 'react'
import Lottie from 'react-lottie'

import SectionBar from '@/components/myTicket/components/myTicketSectionBar/view'

import airportEvent from '@/utils/gaEvents/airportEvent'

import type { AirportTicketDetail } from '@/api/server/airport/dto/airportDto'
import Button from '@/shared/components/button/Button'
import NaverPreLog from '@/shared/components/scripts/NaverPreLog'
import NaverPreLogPurchase from '@/shared/components/scripts/NaverPreLogPurchase'
import { Text } from '@/shared/components/typography'

import purchaseAnimation from '../../../../../../../../public/paymentcheck.json'

const AirportComplete = ({
  data,
  time,
  carNum,
  ticketSeq,
  onClick
}: {
  isComplete: boolean
  data: AirportTicketDetail
  time: string
  carNum: string
  ticketSeq?: number
  onClick: () => void
}) => {
  const defaultOptions = {
    loop: false,
    autoplay: true,
    animationData: purchaseAnimation,
    rendererSettings: {
      preserveAspectRatio: 'xMidYMid slice'
    }
  }
  const [startTime, endTime] = time.split('/')

  useEffect(() => {
    if (!ticketSeq) return
    airportEvent.renderAirportPaymentComplete(
      data.parkinglotSeq,
      data.parkinglotName,
      data.couponSeq,
      data.couponName,
      ticketSeq
    )
  }, [])

  return (
    <div className="absolute left-0 top-0 flex h-full w-full flex-1 flex-col bg-010">
      <div className="flex w-full flex-1 flex-col justify-around px-6 pt-12">
        <div className="flex flex-col items-center gap-6 text-center">
          <Lottie options={defaultOptions} width={50} height={50} />
          <Text level="text1" weight="bold" color="text090">
            주차권 결제 완료
          </Text>
          <Text level="text2">
            주차권 이용을 위해 <br />
            이어서 이용자 정보를 입력해 주세요.
          </Text>
        </div>
        <div className="flex flex-col gap-4">
          <SectionBar border="border-t-[1px]" borderColor="border-030" />
          <div className="flex flex-col gap-4 px-4">
            <div className="flex flex-col gap-[6px]">
              <Text level="text2" color="text090" className="ellipsis">
                {data.parkinglotName}
              </Text>
              <div className="flex justify-between">
                <Text level="text3" color="text070">
                  상품명
                </Text>
                <Text level="text3" color="text070">
                  {data.couponName}
                </Text>
              </div>
              <div className="flex justify-between">
                <Text level="text3" color="text070">
                  입차시간
                </Text>
                <Text level="text3" color="text070">
                  {startTime}
                </Text>
              </div>
              <div className="flex justify-between">
                <Text level="text3" color="text070">
                  출차시간
                </Text>
                <Text level="text3" color="text070">
                  {endTime}
                </Text>
              </div>
              <div className="flex justify-between">
                <Text level="text3" color="text070">
                  차량번호
                </Text>
                <Text level="text3" color="text070">
                  {carNum}
                </Text>
              </div>
            </div>
          </div>
        </div>
      </div>
      <div className="sticky bottom-0 px-4 pb-3">
        <Button
          text="공항 주차 정보 입력"
          className="body-1 h-[56px]"
          pyValue="py-0"
          color="text010"
          background="bg030"
          disabled={false}
          onClick={onClick}
        />
      </div>
      <NaverPreLog />
      <NaverPreLogPurchase />
    </div>
  )
}

export default AirportComplete
